module.exports = __webpack_public_path__ + "img/wzf_6.ef268b06.png";